<template>
<div class="container orders-page">
    <v-head></v-head>
    <v-left current="logistics"></v-left>
    <div>
        <div class="filter-dic clearfix">
            <div class="fl">
                <el-input size="mini" v-model="filter.keyword" placeholder="搜订单号、手机号" clearable @clear="search" @change="search" class="w240 input-with-select">
                    <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
                </el-input>
                <el-select v-model="filter.platform" placeholder="应用类型" clearable @clear="search" @change="search" size="mini" class="w130">
                    <el-option v-for="item in $store.state.public.cfg.platform_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <el-select v-model="filter.app_id" placeholder="应用" size="mini" class="w160" @change="search" @clear="search" clearable>
                    <el-option v-for="item in $store.state.public.cfg.apps_options" :key="item.id" :label="item.label" :value="item.id"></el-option>
                </el-select>
                <el-select v-model="filter.status" placeholder="订单状态" clearable @clear="search" @change="search" size="mini" class="w130">
                    <el-option v-for="item in $store.state.public.cfg.order_status_options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <el-date-picker size="mini" class="w100" v-model="filter.time_range" clearable @change="search" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
            </div>
            <div class="fr">
                <el-button size="mini" class="pointer" @click="popName = 'popImport'">导入单号<i class="el-icon-upload el-icon--right"></i></el-button>
            </div>
        </div>
        <div class="list-dom">
            <el-table :data="list_data.list" v-loading="loading" style="width: 100%">
                <el-table-column prop="order_no" label="订单" width="166">
                    <template slot-scope="scope">
                        <span class="pointer" @click="redirect('/orders/detail?order_id=' + scope.row.orders_id, true)">{{scope.row.orders_no}}</span>
                    </template>                    
                </el-table-column>
                <el-table-column prop="order_no" label="运单号" width="200">
                    <template slot-scope="scope">
                      <p class="gray-color">{{ scope.row.logistics_company_name }}</p>
                      <p class="gray-color">{{ scope.row.logistics_channel_code }},{{ scope.row.logistics_warehouse_code }}</p>
                      <b class="pointer" @click="redirect('/orders/detail?order_id=' + scope.row.orders_id, true)">{{scope.row.track_number}}</b>
                    </template>                    
                </el-table-column>
                <el-table-column prop="status" label="状态" width="133">
                  <template slot-scope="scope">
                    <el-tag >{{ scope.row.status_label }}</el-tag>
                  </template> 
                </el-table-column>
                <el-table-column prop="receiver_address" label="买家" min-width="333">
                  <template slot-scope="scope">
                    <span v-if="scope.row.receiver_name">{{ scope.row.receiver_name }},</span>
                    <span v-if="scope.row.receiver_email">{{ scope.row.receiver_email }},</span>
                    <span v-if="scope.row.receiver_mobile">{{ scope.row.receiver_mobile }},</span>
                    <span v-if="scope.row.receiver_country">{{ scope.row.receiver_country }},</span>
                    <span v-if="scope.row.receiver_province">{{ scope.row.receiver_province }},</span>
                    <span v-if="scope.row.receiver_city">{{ scope.row.receiver_city }},</span>
                    <span v-if="scope.row.receiver_postcode">{{ scope.row.receiver_postcode }},</span>
                    <span v-if="scope.row.receiver_address1">{{ scope.row.receiver_address1 }}</span>
                  </template> 
                </el-table-column>
                <el-table-column prop="ctime" label="导入时间" width="166"></el-table-column>
                <el-table-column label="操作" min-width="100" align="right">
                    <template slot-scope="scope">
                        <el-tag size="mini" type="default" class="pointer" @click="popLogisticsInfo(scope.row)" v-if="scope.row.track_number">查看物流</el-tag>
                        <el-tag size="mini" class="pointer" @click="submit(scope.row)" v-if="scope.row.track_number == '' || true">提交物流</el-tag>
                        <el-tag size="mini" class="pointer" @click="toPopLabel(scope.row)" v-if="scope.row.track_number == '' || true">打印面单</el-tag>
                        <el-tag size="mini" class="pointer" @click="toPopTrace(scope.row)" v-if="scope.row.track_number == '' || true">包裹跟踪</el-tag>
                        <el-tag size="mini" type="info" class="pointer" @click="remove(scope.row)">删除</el-tag>
                    </template>
                </el-table-column>
            </el-table>            
            <el-pagination
                class="my-page"
                background
                :page-size="list_data.size"
                layout="total, prev, pager, next"
                @current-change="changePage"
                :total="list_data.total">
            </el-pagination>        
        </div>

        <component :is="popName" :item="currentItem"></component>
    </div>
</div>
</template>
<script>
import head from '@/pages/public/_head'
import left from '@/pages/public/_left'
const popImport = resolve => require(['@/pages/logistics/_pop_import'], resolve);  
const pop_label = resolve => require(['@/pages/logistics/_pop_label'], resolve);  
const pop_trace = resolve => require(['@/pages/logistics/_pop_track'], resolve);  
export default {
    components:{
        'v-head':head,
        'v-left':left,
        popImport,pop_label,pop_trace
    },
    data(){
        return {
            loading:false,
            popName:null,
            currentItem:null,
            filter:{
              page: 1,
              size:20,
              platform:'',
              keyword:'',
              status:'',
              app_id:'',
              time_range:[],
            },
            list_data:{
                size:20,
                page:1,
                total:0,
                list:[],
            },
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                    }
                }]
            },
        }
    },
    methods:{
      changePage(e){
          this.filter.page =e
          this.getList()
      },
      popLogisticsInfo(row){
          this.currentItem = row;
          this.popName = 'popLogisticsInfo'
      },
      send(row) { 
        this.currentItem = row
        this.popName = 'popSend'
      },
      toPopLabel(row) { 
        this.currentItem = row
        this.popName = 'pop_label'
      },
      toPopTrace(row) { 
        this.currentItem = row
        this.popName = 'pop_trace'
      },
      search(){
          this.filter.page = 1;
          this.getList()
      },
      remove(row) { 
        this.$confirm('确定删除？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
              this.$store.commit('setLoading', {text:'正在删除..'});
              this.$http.post('/v1/pri/logistics/remove', {id:row.id})
                  .then( (response) => {
                      this.$store.commit('setLoading', {text:false});
                      var res = response.data;
                      if (res.code == 1) {
                          this.$message({
                              message: '删除成功',
                              type: 'success'
                          });
                          this.getList()
                      } else {
                          this.$message({
                              message: res.msg,
                              type: 'warning'
                          });
                      }
                  })
          })
      },
      submit(row) { 
        this.$confirm('确定提交？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
              this.$store.commit('setLoading', {text:'正在提交..'});
              this.$http.post('/v1/pri/logistics/submit', {id:row.id})
                  .then( (response) => {
                      this.$store.commit('setLoading', {text:false});
                      var res = response.data;
                      if (res.code == 1) {
                          this.$message({
                              message: '提交成功',
                              type: 'success'
                          });
                          this.getList()
                      } else {
                          this.$message({
                              message: res.msg,
                              type: 'warning'
                          });
                      }
                  })
          }) 
      },
      getList(){
          this.loading = true;
          this.$http.post('/v1/pri/logistics/lists', this.filter)
          .then( (response) => {
              this.loading = false;
              var res = response.data;
              if (res.code == 1) {
                  this.list_data = res.data
              }
          })            
      },
    },
    mounted(){
        this.getList()
    },
}
</script>
<style scoped>
.orders-page .filter-dic{margin-bottom:14px;}
</style>


// WEBPACK FOOTER //
// src/pages/logistics/Index.vue